/**
 * Countdown timer for DRAFT incidents (PRD §5.5 U-06).
 *
 * Counts down the seconds until the H-02 supervisor auto-escalation. The
 * server-side timeout is the source of truth — this component just shows
 * the operator how much time is left visually. Re-renders every second.
 */

import { useEffect, useState } from "react";

export interface CountdownTimerProps {
  /** ISO 8601 timestamp when the incident was created */
  createdAt: string;
  /** seconds the operator has to act (default 60 — env.HITL_TIMEOUT_SECONDS) */
  timeoutSeconds?: number;
}

export function CountdownTimer({
  createdAt,
  timeoutSeconds = 60,
}: CountdownTimerProps) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const elapsedMs = now - new Date(createdAt).getTime();
  const remainingSeconds = Math.max(
    0,
    timeoutSeconds - Math.floor(elapsedMs / 1000),
  );

  let colour = "text-slate-300";
  if (remainingSeconds < 15) colour = "text-rose-400";
  else if (remainingSeconds < 30) colour = "text-amber-300";

  return (
    <span
      className={`font-mono text-sm ${colour}`}
      data-testid="countdown-timer"
      aria-label="seconds remaining until supervisor escalation"
    >
      {remainingSeconds}s
    </span>
  );
}
